export const deClientPortalPlaygroundPages = {
    playground: {
        shared: {
            header: {
                defaultBreadcrumbTitle: 'Tools',
                betaLabel: 'Beta',
                learnMore: 'Mehr erfahren',
                close: 'Schließen',
                modalTitle: 'Mehr über {{title}}',
            },
            feedback: {
                payload: {
                    category: 'Kategorie',
                    incident: 'Incident',
                },
                tool: {
                    triggerLabel: 'Feedback geben',
                    tooltip: 'Feedback geben',
                    title: 'Feedback geben',
                    close: 'Schließen',
                    cancel: 'Abbrechen',
                    submit: 'Absenden',
                    categoryLabel: 'Art des Feedbacks',
                    descriptionLabel: 'Beschreibung',
                    descriptionTooltip: 'Konkrete Beispiele helfen uns am meisten.',
                    descriptionFieldLabel: 'Was ist passiert? Was haben Sie erwartet?',
                    descriptionAriaLabel: 'Beschreibung',
                    incidentLabel: 'Kritisches Anliegen',
                    incidentTooltip:
                        'Kritische Anliegen sind z.B. Fehler, die dich blockieren oder Situationen, in denen du umgehend Hilfe brauchst.',
                    errorMessage:
                        'Leider ist beim Absenden des Feedbacks ein Fehler aufgetreten. Bitte stellen Sie sicher, dass ihr Adblocker auf dieser Seite deaktiviert ist und versuchen Sie es nochmal. Sollte der Fehler weiterhin auftreten, melden Sie sich bitte bei support@einwert.com.',
                    successMessage: 'Vielen Dank für Ihr Feedback!',
                    options: [
                        {
                            title: 'Etwas funktioniert nicht',
                            description: 'z.B. Fehlermeldung, falsches Ergebnis, Absturz',
                        },
                        {
                            title: 'Ergebnis war ungenau',
                            description: 'z.B. falsche Interpretation durch KI, fehlende Antworten',
                        },
                        {
                            title: 'Etwas ist unverständlich',
                            description: 'z.B. Unklare Bedienung, verwirrender Output',
                        },
                        {
                            title: 'Verbesserungsvorschlag',
                            description: 'z.B. Idee, fehlende Funktion, Wunsch',
                        },
                        {
                            title: 'Lob',
                            description: 'z.B. Zeitersparnis, spürbare Hilfe',
                        },
                    ],
                },
            },
            pdfPreview: {
                searchLabel: 'Suche',
                searchPlaceholder: 'PDF durchsuchen',
                previousResult: 'Vorheriger Treffer',
                nextResult: 'Nächster Treffer',
                noResults: 'Keine Treffer gefunden.',
                searchResultMessage: 'Treffer {{current}} von {{total}} (Seite {{page}})',
                pdfLoadError: 'PDF konnte nicht angezeigt werden.',
                previousPage: 'Vorherige Seite',
                nextPage: 'Nächste Seite',
                page: 'Seite',
                zoomOut: 'Verkleinern',
                zoomIn: 'Vergrößern',
            },
            upload: {
                fileSizeErrorMessage: 'Die Datei ist größer als 20 MB. Bitte PDF komprimieren und erneut versuchen.',
                replacePdf: 'PDF ersetzen',
                uploadPdf: 'PDF hochladen',
                uploadValuationPdf: '{{report}} PDF hochladen',
                cancel: 'Abbrechen',
                valuationPdf: '{{report}} PDF',
                dropDescription: 'Ziehe eine PDF hierher oder klicke zum Auswählen.',
                emptyTitle: '{{report}} PDF hochladen',
                sampleButton: 'Mit Beispiel testen',
                sampleTooltip: 'Mit einwert Beispiel Gutachten testen.',
                uploadTooltip: '{{report}} als PDF hochladen',
                restartAnalysis: 'Analyse erneut starten',
                removeFile: 'Datei entfernen',
            },
        },
        tenantListImport: {
            title: 'Mieterliste zu Excel',
            infoText: 'Lassen Sie Ihre Mieterliste auslesen, prüfen Sie das Ergebnis und laden Sie es im einwert-Excel-Format herunter.',
            emptyDescription:
                'Ziehen Sie eine Mieterliste hierher oder wählen Sie eine Datei aus. Excel (.xlsx, .xlsm, .xls) oder PDF, bis 20 MB.',
            replaceFile: 'Datei ersetzen',
            readyToDownload: 'Bereit zum Download',
            format: {
                title: 'einwert-Excel-Format',
                template:
                    'Die Excel-Datei bildet die wichtigsten Mieterinformationen in einem einheitlichen Format ab, welches als Grundlage für Gutachten verwendet wird.',
                periods:
                    'In diesem Format sind je Einheit bis zu vier Mietstaffeln, drei mietfreie Zeiten und drei Leerstandszeiten mit Start- und Enddatum möglich.',
                remarks:
                    'Weitere Zeiträume und Leerstand ohne vollständige Datumsangaben stehen nur in der Bemerkung; fehlende Marktmieten bleiben leer.',
            },
            exportLimitations:
                'Betroffene Einheiten: {{count}}. Zusätzliche Mietstaffeln, Zeiträume oder Leerstand ohne vollständige Datumsangaben werden nur in der Bemerkung gespeichert. Diese Angaben werden beim Vorlagenimport nicht als strukturierte Daten übernommen.',
        },
        valXmlExtractor: {
            title: 'PDF zu {{valXml}}',
            infoText: 'Lassen Sie die wichtigsten Daten automatisiert aus Ihrem Gutachten lesen und als {{valXml}}-Datei exportieren.',
            infoModalItems: [
                'Unser Tool automatisiert das Auslesen und Exportieren der Daten aus Gutachten-PDFs mittels KI und stellt die Daten als {{valXml}} Download zur Verfügung.',
                '{{valXml}} ist ein standardisiertes Dateiformat, das vom Bundesverband der Immobilien-Investment-Sachverständigen (BIIS) für den Austausch von bewertungsbezogenen Daten entwickelt wurde.',
                'Nicht alle Bewertungsmethoden können im {{valXml}}-Format dargestellt werden.',
                'KI kann Fehler machen, bitte überprüfen Sie die Daten bevor Sie diese verwenden. Sie können im Tool manuell Daten hinzufügen, ändern oder entfernen.',
                'Sie benötigen die Daten in einem anderen Format? Schreiben Sie uns Feedback!',
            ],
            emptyDescription: 'Wählen Sie ein Gutachten aus, um Kennzahlen zu extrahieren und als {{valXml}} zu exportieren.',
            aiResponse: {
                language: 'Deutsch (de-DE)',
                requiredImportDefaultNote: 'Pflichtfeld fuer Backend-Import. Kein expliziter Wert im PDF gefunden; Defaultwert gesetzt.',
            },
            progress: {
                defaultExtraction: 'Kennzahlen werden extrahiert',
                extractingSection: '{{section}} werden extrahiert',
            },
            errors: {
                missingReviewData: 'Es liegt noch keine KI-Auswertung zum Prüfen vor.',
                missingReviewKpis: 'Es wurden noch keine KPIs extrahiert, die geprüft werden könnten.',
                noReadableText: 'Im Dokument wurden keine lesbaren Texte gefunden.',
                pdfProcessing: 'Die PDF-Datei konnte nicht verarbeitet werden. Prüfe bitte das Dokument und versuche es erneut.',
                pdfProviderFit:
                    'Die PDF-Datei konnte nicht für die KI-Verarbeitung vorbereitet werden. Bitte prüfen oder komprimieren Sie das Dokument und versuchen Sie es erneut.',
                samplePdf: 'Das Mustergutachten konnte nicht geladen werden.',
                valXmlBuild: 'Die {{valXml}} konnte nicht erstellt werden. Bitte ergänze fehlende {{valXml}}-Pfade und versuche es erneut.',
                authExpired: 'Nicht angemeldet oder Sitzung abgelaufen. Bitte erneut anmelden.',
                forbidden: 'Zugriff verweigert. Dir fehlen Berechtigungen für die KI-Funktion.',
                endpointMissing: 'KI-Endpunkt nicht gefunden. Prüfe VITE_BACKEND_ROUTE und Backend-Verfügbarkeit.',
                rateLimit: 'Limit erreicht. Bitte später erneut versuchen.',
                server: 'Serverfehler bei der KI. Bitte später erneut versuchen.',
                missingToken: 'Nicht angemeldet. Bitte melde dich an und versuche es erneut.',
                responseMissingJson: 'Die KI-Antwort enthielt kein JSON.',
                responseInvalidJson: 'Die KI-Antwort war kein gültiges JSON.',
                responseInvalidFormat: 'Die Extraktionsantwort war nicht im erwarteten JSON-Format.',
                unknown: 'Unbekannter Fehler beim Abrufen der KI-Antwort.',
                genericAiErrorWithMessage: 'Fehler ({{code}}): {{message}}',
                genericAiError: 'Fehler ({{code}}) beim KI-Aufruf.',
            },
            secondaryCheck: {
                invalidJson: 'Die Prüfantwort war kein gültiges JSON. Bitte KI-Antwort prüfen oder den Prüfvorgang erneut starten.',
                invalidFormat: 'Die Prüfantwort war nicht im erwarteten JSON-Format.',
                missingValueReviewNote: 'Fehlender Wert laut KI-Prüfung.',
                noChanges: 'Zusätzliche Prüfung abgeschlossen – keine Änderungen.',
                joinSeparator: ' und ',
                newEntries_one: '{{count}} neuen Eintrag hinzugefügt',
                newEntries_other: '{{count}} neue Einträge hinzugefügt',
                valueChanges_one: 'Werte bei {{count}} Eintrag aktualisiert',
                valueChanges_other: 'Werte bei {{count}} Einträgen aktualisiert',
                proposedChanges_one: '{{count}} Eintrag mit Änderungsvorschlag markiert',
                proposedChanges_other: '{{count}} Einträge mit Änderungsvorschlag markiert',
                confidenceReduced_one: 'Confidence für {{count}} Eintrag reduziert',
                confidenceReduced_other: 'Confidence für {{count}} Einträge reduziert',
            },
            kpiSection: {
                validation: {
                    missingValXmlField: 'Bitte ein {{valXml}}-Feld wählen',
                    missingValue: 'Bitte einen Wert angeben',
                    kpiAdded: 'KPI hinzugefügt',
                },
                labels: {
                    review: 'Überprüfung',
                    page: 'Seite',
                    confidence: 'Confidence',
                    manualConfidence: 'Manuell',
                    valXmlPath: '{{valXml}} Pfad',
                    explanation: 'Erklärung',
                    notes: 'Notizen',
                    codeInterpreterUsed: 'Code Interpreter verwendet',
                    title: 'Kennzahlen',
                    valXml: '{{valXml}}',
                },
                actions: {
                    removeKpi: 'Kennzahl entfernen',
                    copyValue: 'Wert kopieren',
                    acceptProposal: 'Vorschlag übernehmen',
                    rejectProposal: 'Vorschlag verwerfen',
                    addKpi: 'Kennzahl hinzufügen',
                    addMissingKpi: 'Fehlende Kennzahl hinzufügen',
                    reviewTooltip: 'Alle Werte nochmals mittels KI überprüfen',
                    reviewRunning: 'Prüfung läuft',
                    review: 'Überprüfen',
                },
                placeholders: {
                    value: 'Wert eingeben',
                },
                feedback: {
                    valueCopied: 'Wert wurde in die Zwischenablage kopiert',
                    valXmlUnavailable: '{{valXml}} steht noch nicht zur Verfügung',
                    valXmlExportStarted: '{{valXml}}-Export gestartet',
                    extractingInitial: 'Kennzahlen werden extrahiert',
                    extractingMore: 'Weitere Kennzahlen werden extrahiert',
                },
                booleanLabels: {
                    true: 'Ja',
                    false: 'Nein',
                },
                generalSections: {
                    appraiserInspection: 'Gutachter & Besichtigung',
                    valuationResults: 'Bewertungsergebnisse',
                    costsDeductions: 'Kosten & Abzüge',
                    addressOwner: 'Adresse & Eigentümer',
                    otherKeyFigures: 'Weitere Kennzahlen',
                },
                rentalSections: {
                    archive: 'Archiv',
                    businessGeneral: 'Gewerbe',
                    gastronomy: 'Gastronomie',
                    hotel: 'Hotel',
                    indoorParking: 'Innenstellplätze',
                    leisure: 'Freizeit',
                    office: 'Büro',
                    outdoorParking: 'Außenstellplätze',
                    residential: 'Wohnen',
                    retail: 'Handel',
                    social: 'Sozial',
                    storage: 'Lager',
                    otherUsage: 'Sonstige Nutzung',
                },
                valXmlFields: {
                    labels: {},
                    descriptions: {},
                    rentalUsageLabels: {},
                    rentalFieldLabels: {},
                    rentalDescription: '',
                },
                addModal: {
                    title: 'Neue Kennzahl hinzufügen',
                    add: 'Hinzufügen',
                    cancel: 'Abbrechen',
                    fieldLabel: 'Kennzahl',
                    fieldPlaceholder: 'Kennzahl auswählen',
                    valueLabel: 'Wert',
                    fallbackRentalUsage: 'Allgemein',
                    generalGroupLabel: 'Allgemeine Kennzahlen',
                    rentalGroupLabel: 'Mietaufstellung – {{usage}}',
                    expectedType: 'Erwarteter Typ: {{type}}',
                },
            },
        },
        pdfValidator: {
            title: 'KI-Plausibilisierung',
            infoText: 'Prüfen Sie Ihre Gutachten KI-unterstützt mit der Plausibilisierung.',
            upload: {
                sampleTooltip: 'Mit einwert Beispiel Gutachten testen',
            },
            infoModalItems: [
                'Durch eine Kombination aus vordefinierten Standard-Checks und Ihren eigenen Prüffragen erhalten Sie schnell Antworten zu dem vorliegenden Gutachten.',
                'Sie können die Prüffragen vom letzten Durchlauf laden und so schnell dieselben Checks auf einem neuen Gutachten wiederholen.',
                'Die Standard-Checks werden sofort automatisch ausgeführt. Sie können Ihre eigenen Prüffragen hinzufügen und diese dann mit Klick auf "{{startLabel}}" einreihen.',
                'Der Klick auf eine Antwort führt zu der relevanten Passage des Gutachtens und dient zur Kontrolle der KI-Resultate.',
                'Sie können Ihre eigenen Anmerkungen im Notizfeld hinterlegen und anschließend mit Anderen teilen.',
            ],
            emptyDescription: 'Wählen Sie ein Gutachten aus, um mit der Plausibilisierung zu starten.',
            answerLabels: {
                yes: 'Ja',
                no: 'Nein',
                textAnswer: 'Textantwort',
                unknown: 'Unklar',
            },
            errors: {
                noClearAnswer: 'Keine eindeutige Antwort im Dokument gefunden.',
                retryValidation:
                    'Ein Teil der Plausibilisierung ist fehlgeschlagen. Bitte klicken Sie erneut auf "{{startLabel}}", damit alle offenen Checks und Prüffragen beantwortet werden.',
                noReadableText: 'Im Dokument wurden keine lesbaren Texte gefunden.',
                tableOfContentsLoadingFailed:
                    'Das Inhaltsverzeichnis konnte nicht geladen werden. Die Plausibilisierung kann trotzdem gestartet werden.',
                pdfProcessing: 'Die PDF-Datei konnte nicht verarbeitet werden. Prüfe bitte das Dokument und versuche es erneut.',
                pdfProviderFit:
                    'Die PDF-Datei konnte nicht für die KI-Verarbeitung vorbereitet werden. Bitte prüfen oder komprimieren Sie das Dokument und versuchen Sie es erneut.',
                samplePdf: 'Das Mustergutachten konnte nicht geladen werden.',
                sessionExpiredTitle: 'Sitzung abgelaufen',
                sessionExpiredDescription:
                    'Die AI-Session war mehr als 30 Minuten inaktiv und ist abgelaufen. Lade die Seite neu, um mit einer frischen Session weiterzuarbeiten.',
            },
            progress: {
                tableOfContents: 'Inhaltsverzeichnis wird geladen',
            },
            standardChecks: {
                title: 'Standard Checks',
                tooltip: 'Diese Beispiel Standard-Checks sind aktuell auf Folgebewertungen ausgerichtet. Weitere Bewertungsarten folgen.',
                questions: [
                    {
                        id: 'standard_check_aktuelle_quellen',
                        question: 'Die Marktdaten Quellen sind nicht älter als zwei Jahre vor Wertermittungsstichtag',
                    },
                    {
                        id: 'standard_check_grundbuchauszug',
                        question: 'Der Grundbuchauszug ist maximal drei Jahre alt',
                    },
                    {
                        id: 'standard_check_wirtschaftliches_baujahr',
                        question: 'Das wirtschaftliche Baujahr hat sich nicht verändert',
                    },
                    {
                        id: 'standard_check_besichtigung_hauptgutachter',
                        question: 'Die Besichtigung wurde u.a. durch den Hauptgutachter durchgeführt',
                    },
                ],
            },
            tableOfContents: {
                title: 'Inhaltsverzeichnis',
                loading: 'Inhaltsverzeichnis wird geladen',
                empty: 'Keine Hauptabschnitte erkannt.',
                pending: 'Das Inhaltsverzeichnis wird nach dem Upload automatisch erstellt.',
            },
            notes: {
                title: 'Notizen',
                copy: 'Notizen kopieren',
                placeholder: 'Sammeln Sie hier Ihre Anmerkungen',
                textEditor: {
                    toolbar: {
                        textStyle: 'Textstil',
                        bold: 'Fett',
                        italic: 'Kursiv',
                        bulletedList: 'Aufzählung',
                        numberedList: 'Nummerierte Liste',
                        headingOptions: {
                            paragraph: 'Text',
                            h2: 'Headline 1',
                            h3: 'Headline 2',
                            h4: 'Headline 3',
                            h5: 'Headline 4',
                        },
                    },
                },
            },
            questions: {
                title: 'Prüffragen',
                queued: 'Prüffragen eingereiht',
                start: 'Plausibilisierung starten',
                startInfo: 'Plausibilisierung starten, um unbeantwortete Fragen zu beantworten.',
                newPlaceholder: 'Neue Frage ...',
                create: 'Prüffrage erstellen',
                emptyWithPersisted:
                    'Fügen Sie eigene Prüffragen hinzu, starten Sie mit Beispielfragen oder laden Sie die Fragen der letzten Plausibilisierung.',
                emptyWithoutPersisted: 'Fügen Sie eigene Prüffragen hinzu oder starten Sie mit Beispielfragen.',
                generateExamples: 'Beispielfragen generieren',
                loadPast: 'Vergangene Fragen laden',
                save: 'Prüffrage speichern',
                cancelEdit: 'Bearbeitung abbrechen',
                edit: 'Prüffrage bearbeiten',
                delete: 'Prüffrage löschen',
                examples: [
                    'Woraus resultieren die wesentlichen Änderungen zur Vorbewertung?',
                    'Wurden die CapEx-Maßnahmen so beschrieben, dass sie für einen unabhängigen Dritten nachvollziehbar sind?',
                    'Wurde die Veränderung des LZ so beschrieben, dass sie für einen unabhängigen Dritten nachvollziehbar ist?',
                    'Es gibt keine logische Widersprüche im Gutachten. Falls doch, liste alle.',
                    'Es gibt keine Rechtschreibfehler im Dokument. Falls doch, liste alle.',
                    'Es gibt keine verbleibende Platzhalter im Dokument. Falls doch, liste alle.',
                    'Die Gegenüberstellung zur Vorbewertung rechnet die korrekte absolute und prozentuale Veränderung.',
                ],
            },
            actions: {
                reloadPage: 'Seite neu laden',
            },
        },
    },
}
